// extracted by mini-css-extract-plugin
export var dangerMsgStyle = "subscriptionForm-module--dangerMsgStyle--75574";
export var formContainer = "subscriptionForm-module--formContainer--b5afc";